/**
 * Round-2 fix: columns for GstSummary.tsx's rows, on packages/theme's real list machinery
 * (`useTanStackTable` + `MainTable`) — replaces a hand-rolled `<Table variant="modern">` that was
 * a straight rename of the old shadcn Table, not a re-composition of any template file. Plain
 * `ColumnDef[]`, matching the convention already used by `../orders/columns.tsx` and
 * `./columns.tsx`.
 *
 * Accessors so a header click sorts the whole fetched summary — each figure on the API's own value
 * read as a number, shown as sent; figures right-align through `meta.align`.
 *
 * Only the data, columns and labels are ours. The screen-to-template mapping is
 * specs/017-isomorphic-theme-only/contracts/screen-map.md.
 */
import type { ColumnDef } from "@tanstack/react-table";
import { money, statusWords } from "../../lib/services/invoicing";
import type { GstRow } from "./GstSummary";

export const gstSummaryColumns: ColumnDef<GstRow>[] = [
  { id: "financialYear", accessorKey: "financialYear", header: "Financial year", cell: ({ row }) => row.original.financialYear },
  { id: "gstRate", accessorFn: (row) => Number(row.gstRate), header: "GST rate", meta: { align: "right" }, cell: ({ row }) => `${String(row.original.gstRate)}%` },
  { id: "taxHead", accessorFn: (row) => statusWords(row.taxHead), header: "Tax head", cell: ({ row }) => statusWords(row.original.taxHead) },
  { id: "taxableValue", accessorFn: (row) => Number(row.taxableValue), header: "Taxable value", meta: { align: "right" }, cell: ({ row }) => money(row.original.taxableValue) },
  { id: "cgst", accessorFn: (row) => Number(row.cgst), header: "CGST", meta: { align: "right" }, cell: ({ row }) => money(row.original.cgst) },
  { id: "sgst", accessorFn: (row) => Number(row.sgst), header: "SGST", meta: { align: "right" }, cell: ({ row }) => money(row.original.sgst) },
  { id: "igst", accessorFn: (row) => Number(row.igst), header: "IGST", meta: { align: "right" }, cell: ({ row }) => money(row.original.igst) },
];
